import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { UserService } from '../../user/user.service';
import { PushService } from '../../push/push.service';
import { filter, map, switchMap } from 'rxjs/operators';
import { AsyncPipe, JsonPipe } from '@angular/common';
import { ModalComponent } from '@styleguide/modal/modal/modal.component';
import { ConfirmationModalComponent } from '../../confirmation/confirmation-modal/confirmation-modal.component';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { IfInstitutionTypeDirective } from '../../app-context/if-institution-type.directive';

@Component({
  selector: 'kgr-aks-for-push-notification-permissions',
  imports: [AsyncPipe, JsonPipe, ModalComponent, ConfirmationModalComponent, IfInstitutionTypeDirective],
  templateUrl: './aks-for-push-notification-permissions.component.html',
  styleUrl: './aks-for-push-notification-permissions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AksForPushNotificationPermissionsComponent {
  userService = inject(UserService);
  pushService = inject(PushService);

  showPermissionNotGrantedHint = signal(false);

  hide$ = new BehaviorSubject(false);

  show$ = combineLatest([this.userService.loggedIn$, this.pushService.permission$, this.pushService.enabled$, this.hide$]).pipe(
    map(([loggedIn, permission, enabled, hide]) => {
      return loggedIn && permission !== 'granted' && enabled === undefined && !hide;
    }),
  );

  onConfirm() {
    this.pushService.requestPermission().subscribe({
      next: (result) => {
        if (result === 'granted') {
          this.pushService.enable();
        } else {
          this.showPermissionNotGrantedHint.set(true);
        }
      },
    });
  }

  onDecline() {
    this.pushService.disable();
  }

  onCancel() {
    this.hide$.next(true);
  }
}
